var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22C9 24.4853 6.98528 26.5 4.5 26.5C2.01472 26.5 0 24.4853 0 22C0 19.5147 2.01472 17.5 4.5 17.5C6.98528 17.5 9 19.5147 9 22Z",
    fill: "#0A66EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65531 20.6797C5.85527 20.4894 6.17194 20.4974 6.36234 20.6972C6.55261 20.8972 6.54467 21.2139 6.34476 21.4043L4.24515 23.4043C4.05204 23.5881 3.74781 23.5882 3.55472 23.4043L2.65531 22.5469C2.45539 22.3564 2.44735 22.0398 2.63773 21.8398C2.82816 21.6399 3.14479 21.6328 3.34476 21.8232L3.89945 22.3506L5.65531 20.6797Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.5C26.5 14.9853 24.4853 17 22 17C19.5147 17 17.5 14.9853 17.5 12.5C17.5 10.0147 19.5147 8 22 8C24.4853 8 26.5 10.0147 26.5 12.5Z",
    fill: "#0A66EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1553 11.1797C23.3553 10.9894 23.6719 10.9974 23.8623 11.1972C24.0526 11.3972 24.0447 11.7139 23.8448 11.9043L21.7451 13.9043C21.552 14.0881 21.2478 14.0882 21.0547 13.9043L20.1553 13.0469C19.9554 12.8564 19.9474 12.5398 20.1377 12.3398C20.3282 12.1399 20.6448 12.1328 20.8448 12.3232L21.3994 12.8506L23.1553 11.1797Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5C9 6.98528 6.98528 9 4.5 9C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0C6.98528 0 9 2.01472 9 4.5Z",
    fill: "#0A66EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65531 3.17967C5.85527 2.9894 6.17194 2.99736 6.36234 3.19724C6.55261 3.39722 6.54467 3.71389 6.34476 3.90428L4.24515 5.90428C4.05204 6.08815 3.74781 6.08817 3.55472 5.90428L2.65531 5.04685C2.45539 4.85643 2.44735 4.53978 2.63773 4.33982C2.82816 4.13987 3.14479 4.13281 3.34476 4.32322L3.89945 4.85056L5.65531 3.17967Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0605 0.900391C13.3919 0.900391 13.6602 1.16863 13.6602 1.5V24.5C13.6602 24.8314 13.3919 25.0996 13.0605 25.0996C12.7292 25.0996 12.4609 24.8314 12.4609 24.5V1.5C12.4609 1.16863 12.7292 0.900391 13.0605 0.900391Z",
    fill: "#FF435B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0605 0.900391C13.3919 0.900391 13.6602 1.16863 13.6602 1.5V24.5C13.6602 24.8314 13.3919 25.0996 13.0605 25.0996C12.7292 25.0996 12.4609 24.8314 12.4609 24.5V1.5C12.4609 1.16863 12.7292 0.900391 13.0605 0.900391Z",
    fill: "#2F91E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 7.5C14.5625 8.32843 13.8909 9 13.0625 9C12.2341 9 11.5625 8.32843 11.5625 7.5C11.5625 6.67157 12.2341 6 13.0625 6C13.8909 6 14.5625 6.67157 14.5625 7.5Z",
    fill: "#2F91E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.5C14.5 16.3284 13.8284 17 13 17C12.1716 17 11.5 16.3284 11.5 15.5C11.5 14.6716 12.1716 14 13 14C13.8284 14 14.5 14.6716 14.5 15.5Z",
    fill: "#2F91E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 24.5C14.5625 25.3284 13.8909 26 13.0625 26C12.2341 26 11.5625 25.3284 11.5625 24.5C11.5625 23.6716 12.2341 23 13.0625 23C13.8909 23 14.5625 23.6716 14.5625 24.5Z",
    fill: "#2F91E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTimelineIcon);
export default __webpack_public_path__ + "static/media/activityTimelineIcon.e03d0b83446da2967aba9fc1cc6413e3.svg";
export { ForwardRef as ReactComponent };